import { motion } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react";
import { BUSINESS } from "@/data/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-charcoal text-sand">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-24">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-serif text-5xl sm:text-7xl lg:text-8xl leading-[0.95] tracking-tight max-w-4xl"
        >
          Let's talk about
          <span className="block italic text-sage"> caring for your family.</span>
        </motion.h2>

        <a
          href={BUSINESS.phoneHref}
          data-testid="footer-call-button"
          className="mt-10 inline-flex items-center gap-3 rounded-full bg-sage text-white px-8 py-4 font-medium hover:bg-sage-dark transition-colors"
        >
          <Phone className="h-5 w-5" /> Call {BUSINESS.phoneDisplay}
        </a>

        <div className="mt-20 grid grid-cols-1 sm:grid-cols-3 gap-10 border-t border-sand/15 pt-12">
          <div>
            <p className="font-serif text-2xl">HomeCare <span className="italic text-sage">by Nicole</span></p>
            <p className="mt-3 text-sand/60 text-sm max-w-xs leading-relaxed">
              Private-duty, non-medical in-home care from a Certified Nursing
              Assistant with 15+ years of experience.
            </p>
          </div>
          <div className="space-y-3 text-sm">
            <a href={BUSINESS.phoneHref} className="flex items-center gap-3 text-sand/80 hover:text-sand transition-colors">
              <Phone className="h-4 w-4 text-sage" /> {BUSINESS.phoneDisplay}
            </a>
            <a href={BUSINESS.emailHref} className="flex items-center gap-3 text-sand/80 hover:text-sand transition-colors">
              <Mail className="h-4 w-4 text-sage" /> {BUSINESS.email}
            </a>
            <p className="flex items-center gap-3 text-sand/80">
              <MapPin className="h-4 w-4 text-sage" /> {BUSINESS.area}
            </p>
          </div>
          <div className="space-y-3 text-sm">
            <a href="#meet-nicole" className="block text-sand/70 hover:text-sand transition-colors">Meet Nicole</a>
            <a href="#services" className="block text-sand/70 hover:text-sand transition-colors">Services</a>
            <a href="#reviews" className="block text-sand/70 hover:text-sand transition-colors">Reviews</a>
            <a href="#contact" className="block text-sand/70 hover:text-sand transition-colors">Contact</a>
            <a href="/portal/login" data-testid="footer-portal-link" className="block text-sand/70 hover:text-sand transition-colors">Care Portal</a>
          </div>
        </div>

        <p className="mt-14 text-xs text-sand/40">
          © {new Date().getFullYear()} HomeCare by Nicole · Serving Grand Junction & Mesa County, Colorado.
        </p>
      </div>
    </footer>
  );
};
